import React from 'react';
import LoginContainer from './LoginContainer';
import { breakpoint } from '../../styling/mixins/breakpoints';
import styled from 'styled-components';
import { section, grid } from '../../styling/utils/grid';
import { getColor } from '../../styling/mixins/colors';
import { text } from '../../styling/mixins/typography';

const StyledLoginContainer = styled.div`
  ${section}
  ${grid}
  padding-top: 2.4rem;
  padding-bottom: 2.4rem;
  place-items: center;

  ${breakpoint('medium')} {
    padding-top: 3.2rem;
    padding-bottom: 3.2rem;
  }

  ${breakpoint('large')} {
    padding-top: 4rem;
    padding-bottom: 4rem;
  }

  .error {
    ${text('small')}
    color: ${getColor('alert')};
    margin-bottom: 1.6rem;
  }
`;

const StyledLoginWrapper = styled.div`
  width: 100%;

  ${breakpoint('small')} {
    max-width: 480px;
  }
`;
const LoginPage = () => {
  return (
    <StyledLoginContainer>
      <StyledLoginWrapper>
        <LoginContainer />
      </StyledLoginWrapper>
    </StyledLoginContainer>
  );
};
export default LoginPage;
